import React, { useState } from 'react';
import { PlusIcon, TagIcon, TrashIcon, PencilIcon } from 'lucide-react';
const PromoCodeManager = () => {
  const [promoCodes, setPromoCodes] = useState([{
    id: 1,
    code: 'EARLY10',
    discount: '10%',
    type: 'Percentage',
    description: 'Early payment discount',
    validUntil: '2023-12-31',
    status: 'Active'
  }, {
    id: 2,
    code: 'WELCOME25',
    discount: '25%',
    type: 'Percentage',
    description: 'New customer discount',
    validUntil: '2023-09-30',
    status: 'Active'
  }, {
    id: 3,
    code: 'FLAT50',
    discount: '$50',
    type: 'Fixed Amount',
    description: 'Flat discount for orders over $500',
    validUntil: '2023-08-15',
    status: 'Inactive'
  }]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newPromo, setNewPromo] = useState({
    code: '',
    discount: '',
    type: 'Percentage',
    description: '',
    validUntil: ''
  });
  const handleAddPromo = () => {
    const newId = Math.max(...promoCodes.map(promo => promo.id)) + 1;
    setPromoCodes([...promoCodes, {
      id: newId,
      code: newPromo.code,
      discount: newPromo.type === 'Percentage' ? `${newPromo.discount}%` : `$${newPromo.discount}`,
      type: newPromo.type,
      description: newPromo.description,
      validUntil: newPromo.validUntil,
      status: 'Active'
    }]);
    setNewPromo({
      code: '',
      discount: '',
      type: 'Percentage',
      description: '',
      validUntil: ''
    });
    setShowAddForm(false);
  };
  const toggleStatus = (id: number) => {
    setPromoCodes(promoCodes.map(promo => promo.id === id ? {
      ...promo,
      status: promo.status === 'Active' ? 'Inactive' : 'Active'
    } : promo));
  };
  const deletePromo = (id: number) => {
    setPromoCodes(promoCodes.filter(promo => promo.id !== id));
  };
  return <div className="space-y-6" data-id="element-470">
      <div className="flex justify-between items-center" data-id="element-471">
        <div data-id="element-472">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-473">
            Promo Code Manager
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-474">
            Create and manage promotional codes for your customers
          </p>
        </div>
        <button type="button" onClick={() => setShowAddForm(true)} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-475">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-476" />
          Add Promo Code
        </button>
      </div>
      {showAddForm && <div className="bg-white shadow sm:rounded-lg" data-id="element-477">
          <div className="px-4 py-5 sm:p-6" data-id="element-478">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-479">
              Create New Promo Code
            </h3>
            <div className="mt-5 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-480">
              <div className="sm:col-span-2" data-id="element-481">
                <label htmlFor="promo-code" className="block text-sm font-medium text-gray-700" data-id="element-482">
                  Promo Code
                </label>
                <div className="mt-1" data-id="element-483">
                  <input type="text" name="promo-code" id="promo-code" value={newPromo.code} onChange={e => setNewPromo({
                ...newPromo,
                code: e.target.value
              })} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="e.g. SUMMER20" data-id="element-484" />
                </div>
              </div>
              <div className="sm:col-span-2" data-id="element-485">
                <label htmlFor="discount-type" className="block text-sm font-medium text-gray-700" data-id="element-486">
                  Discount Type
                </label>
                <div className="mt-1" data-id="element-487">
                  <select id="discount-type" name="discount-type" value={newPromo.type} onChange={e => setNewPromo({
                ...newPromo,
                type: e.target.value
              })} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-488">
                    <option data-id="element-489">Percentage</option>
                    <option data-id="element-490">Fixed Amount</option>
                  </select>
                </div>
              </div>
              <div className="sm:col-span-2" data-id="element-491">
                <label htmlFor="discount-value" className="block text-sm font-medium text-gray-700" data-id="element-492">
                  Discount Value
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-493">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-494">
                    <span className="text-gray-500 sm:text-sm" data-id="element-495">
                      {newPromo.type === 'Percentage' ? '%' : '$'}
                    </span>
                  </div>
                  <input type="text" name="discount-value" id="discount-value" value={newPromo.discount} onChange={e => setNewPromo({
                ...newPromo,
                discount: e.target.value
              })} className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 sm:text-sm border-gray-300 rounded-md" placeholder={newPromo.type === 'Percentage' ? '10' : '25'} data-id="element-496" />
                </div>
              </div>
              <div className="sm:col-span-3" data-id="element-497">
                <label htmlFor="description" className="block text-sm font-medium text-gray-700" data-id="element-498">
                  Description
                </label>
                <div className="mt-1" data-id="element-499">
                  <input type="text" name="description" id="description" value={newPromo.description} onChange={e => setNewPromo({
                ...newPromo,
                description: e.target.value
              })} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="e.g. Summer sale discount" data-id="element-500" />
                </div>
              </div>
              <div className="sm:col-span-3" data-id="element-501">
                <label htmlFor="valid-until" className="block text-sm font-medium text-gray-700" data-id="element-502">
                  Valid Until
                </label>
                <div className="mt-1" data-id="element-503">
                  <input type="date" name="valid-until" id="valid-until" value={newPromo.validUntil} onChange={e => setNewPromo({
                ...newPromo,
                validUntil: e.target.value
              })} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-504" />
                </div>
              </div>
            </div>
            <div className="mt-5 flex justify-end space-x-3" data-id="element-505">
              <button type="button" onClick={() => {
            setShowAddForm(false);
            setNewPromo({
              code: '',
              discount: '',
              type: 'Percentage',
              description: '',
              validUntil: ''
            });
          }} className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-506">
                Cancel
              </button>
              <button type="button" onClick={handleAddPromo} disabled={!newPromo.code || !newPromo.discount || !newPromo.description || !newPromo.validUntil} className={`inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white ${!newPromo.code || !newPromo.discount || !newPromo.description || !newPromo.validUntil ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'}`} data-id="element-507">
                Create Promo Code
              </button>
            </div>
          </div>
        </div>}
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-508">
        <div className="px-4 py-5 sm:px-6 flex justify-between items-center" data-id="element-509">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-510">
            Active Promo Codes
          </h3>
          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-511">
            {promoCodes.filter(promo => promo.status === 'Active').length}{' '}
            Active
          </span>
        </div>
        <div className="border-t border-gray-200" data-id="element-512">
          <ul className="divide-y divide-gray-200" data-id="element-513">
            {promoCodes.map(promo => <li key={promo.id} className="px-4 py-4 sm:px-6" data-id="element-514">
                <div className="flex items-center justify-between" data-id="element-515">
                  <div className="flex items-center" data-id="element-516">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-517">
                      <TagIcon className="h-6 w-6 text-blue-600" data-id="element-518" />
                    </div>
                    <div className="ml-4" data-id="element-519">
                      <div className="flex items-center" data-id="element-520">
                        <h3 className="text-sm font-medium text-gray-900" data-id="element-521">
                          {promo.code}
                        </h3>
                        <span className={`ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${promo.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-522">
                          {promo.status}
                        </span>
                      </div>
                      <div className="mt-1 text-sm text-gray-500" data-id="element-523">
                        <p data-id="element-524">{promo.description}</p>
                        <p className="mt-1" data-id="element-525">
                          {promo.discount}{' '}
                          {promo.type === 'Percentage' ? 'off' : 'discount'} •
                          Valid until{' '}
                          {new Date(promo.validUntil).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex space-x-2" data-id="element-526">
                    <button type="button" onClick={() => toggleStatus(promo.id)} className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-527">
                      {promo.status === 'Active' ? 'Deactivate' : 'Activate'}
                    </button>
                    <button type="button" className="inline-flex items-center px-2 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-528">
                      <PencilIcon className="h-3.5 w-3.5" data-id="element-529" />
                    </button>
                    <button type="button" onClick={() => deletePromo(promo.id)} className="inline-flex items-center px-2 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-530">
                      <TrashIcon className="h-3.5 w-3.5 text-red-500" data-id="element-531" />
                    </button>
                  </div>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
};
export default PromoCodeManager;